import { Box } from "@chakra-ui/react";
import { type ReactNode, useState } from "react";
import {
	useFloating,
	autoUpdate,
	offset,
	flip,
	shift,
	useHover,
	useFocus,
	useDismiss,
	useRole,
	useInteractions,
	type Placement,
} from "@floating-ui/react";

const Tooltip = ({
	content,
	children,
	placement = "top",
	w = "min(fit-content,30rem,90vw)",
	fontSize = undefined,
}: {
	content?: string;
	children: string | ReactNode;
	placement?: Placement;
	w?: string;
	fontSize?: string;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const {
		refs,
		floatingStyles: style,
		context,
	} = useFloating({
		open: isOpen,
		placement,
		onOpenChange: setIsOpen,
		middleware: [offset(10), flip(), shift()],
		whileElementsMounted: autoUpdate,
	});
	const hover = useHover(context, { move: false });
	const focus = useFocus(context);
	const dismiss = useDismiss(context);
	const role = useRole(context, {
		role: "tooltip",
	});
	const { getReferenceProps, getFloatingProps } = useInteractions([
		hover,
		focus,
		dismiss,
		role,
	]);

	if (!content) return children;
	return (
		<Box ref={refs.setReference} {...getReferenceProps}>
			{children}
			{isOpen && (
				<Box
					ref={refs.setFloating}
					style={style}
					{...getFloatingProps()}
					bgColor="white"
					p={2}
					borderRadius="md"
					boxShadow="md"
					w={w}
					fontSize={fontSize}
					textAlign="center"
					zIndex={10000}
				>
					{content}
				</Box>
			)}
		</Box>
	);
};

export default Tooltip;
